import React from 'react';
import BlueContainer from '../components/blue-container';
import PoweredBy from '../components/powered-by';
import Paragraph from '../components/paragraph';

const CompletedPage = () => (
  <BlueContainer>
    <Paragraph type="title">This Refill Questionnaire has already been completed.</Paragraph>
    <PoweredBy />
  </BlueContainer>
);

export default CompletedPage;
